import { useQuery } from '@apollo/client';

import {
  GetLoyaltyStateQuery,
  GetLoyaltyStateQueryVariables,
} from '@notino/shared/definitions/types';

import { useUser } from '@queries/useUser';

import getLoyaltyState from '../queries/loyaltyState.graphql';

export const useLoyaltyStateQuery = ({
  shouldSkip,
}: {
  shouldSkip?: boolean;
} = {}) => {
  const { isLoggedIn } = useUser();

  return useQuery<GetLoyaltyStateQuery, GetLoyaltyStateQueryVariables>(
    getLoyaltyState,
    {
      ssr: true,
      skip: !isLoggedIn || shouldSkip,
    }
  );
};
